/**
 * Environment access that works both ways:
 *  - runtime-env.js (written at dyno boot from Heroku config vars) wins,
 *    which makes a built slug environment-agnostic and promotable;
 *  - otherwise the value webpack inlined at build time is used (local dev,
 *    plain builds).
 *
 * The fallbacks MUST stay static property accesses - webpack's DefinePlugin
 * only substitutes `process.env.X` literals, never dynamic lookups.
 */
const buildTimeEnv: { [key: string]: string | undefined } = {
    API_URI: process.env.API_URI,
    REACT_APP_FB_API_KEY: process.env.REACT_APP_FB_API_KEY,
    REACT_APP_FB_AUTH_DOMAIN: process.env.REACT_APP_FB_AUTH_DOMAIN,
    REACT_APP_FB_DATABASE_URL: process.env.REACT_APP_FB_DATABASE_URL,
    REACT_APP_FB_PROJECT_ID: process.env.REACT_APP_FB_PROJECT_ID,
    REACT_APP_FB_STORAGE_BUCKET: process.env.REACT_APP_FB_STORAGE_BUCKET,
    REACT_APP_FB_MESSAGING_SENDER_ID: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
    REACT_APP_FB_APP_ID: process.env.REACT_APP_FB_APP_ID,
    REACT_APP_FB_MEASUREMENT_ID: process.env.REACT_APP_FB_MEASUREMENT_ID,
    REACT_APP_ENABLE_WEBRTC: process.env.REACT_APP_ENABLE_WEBRTC,
};

const runtimeEnv: { [key: string]: string | undefined } =
    (typeof window !== 'undefined' && (window as any).__RUNTIME_ENV__) || {};

export function env(key: string): string | undefined {
    const runtime = runtimeEnv[key];
    return runtime !== undefined && runtime !== '' ? runtime : buildTimeEnv[key];
}
